module.exports = "\n\n/*# sourceMappingURL=header.component.css.map */\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/header/header.component.css
// module id = ./src/app/header/header.component.css
// module chunks = main